import { FormBuilder } from '@angular/forms';

import { GridApi, GridOptions } from '@ag-grid-community/core';

export const defaultGridOptions: GridOptions = {
  animateRows: true,
  defaultColDef: {
    filter: true,
    resizable: true,
    sortable: true,
  },
};

export function copySelectedGridRows(gridApi: GridApi = this.agGrid.api): void {
  const text: string = gridApi
    .getSelectedRows()
    .map((row) => {
      return Object.keys(row)
        .map((key) => {
          if (row[key] && !row[key].toString().includes('[object Object]')) {
            return row[key];
          }
        })
        .join('\t');
    })
    .join('\n');

  navigator.clipboard.writeText(text);
}

export function colprefToFormGroup(formBuilder: FormBuilder, colprefs: any[]) {
  return formBuilder.group(
    colprefs.reduce((formGroup, colPref) => {
      formGroup[colPref.field] = formBuilder.group(colPref);
      return formGroup;
    }, {})
  );
}

export function formatNumber(value: any) {
  if (typeof value === 'number') {
    return Math.floor(value)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  return '0';
}

export function formatDecimal(value: any) {
  if (typeof value === 'number') {
    return (Math.round(value * 100) / 100)
      .toFixed(2)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  return '0';
}

export function formatEmpty(obj: any) {
  if (obj === undefined || obj === null || (typeof obj === 'object' && Object.entries(obj).length === 0)) {
    return '';
  }
  return obj;
}

export function isColumnHidden(columns: any, name: any) {
  if (!columns || !(columns instanceof Array)) {
    return false;
  }

  let lColumns = columns.slice(0);
  lColumns = columns.filter((x) => x.colId === name);

  if (!lColumns || lColumns.length === 0) {
    return false;
  }

  return lColumns[0].hide;
}

export function descAlphaFilter(a: any, b: any) {
  if (a?.colId < b?.colId || a?.headerName < b?.headerName) {
    return -1;
  }
  if (a?.colId > b?.colId || a?.headerName < b?.headerName) {
    return 1;
  }
  return 0;
}
